import React, { forwardRef, ReactElement, RefAttributes } from 'react';
import { GroupBase, useStateManager } from 'react-select';
import { ISelectProps, Select, SelectRefType } from './Select';
import { AsyncProps, useAsync } from 'react-select/async';
import { useDebounceLoadOptions } from './selectHelpers';
import ReactSelectType from 'react-select/dist/declarations/src/Select';

export interface ISelectAsyncProps extends ISelectProps {
  debounceInMs?: number;
}

export type SelectAsyncType = <Option = unknown, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
  props: ISelectAsyncProps & AsyncProps<Option, IsMulti, Group> & RefAttributes<ReactSelectType<Option, IsMulti, Group>>
) => ReactElement;

export const SelectAsync = forwardRef(
  <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
    { loadOptions, debounceInMs, ...rest }: ISelectAsyncProps & AsyncProps<Option, IsMulti, Group>,
    ref: SelectRefType<Option, IsMulti, Group>
  ) => {
    let selectProps = rest;
    if (loadOptions) {
      const debouncedLoadOptions = useDebounceLoadOptions(loadOptions, debounceInMs);
      const stateManagedProps = useAsync({ ...rest, loadOptions: debouncedLoadOptions });
      selectProps = useStateManager(stateManagedProps);
    }

    return <Select ref={ref} {...selectProps} />;
  }
) as SelectAsyncType;
